import React, {useEffect, useState} from 'react';
import {
  ISupplierUserProfile,
  IGenericType,
  IFdLiability,
} from 'constants/interfaces';
import {
  reduxToggleSidePanel,
  reduxSetSidePanelEditState,
} from 'appredux/actions';
import {apiGetFdLiabilities, apiUpsertFdLiability} from 'constants/Api';
import {Box} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
import {
  FdLiabilityForm,
  Submission,
} from 'components/applications/FdLiabilityForm';

const AddOrUpdateFdLiability = (props: {
  user: ISupplierUserProfile;
  liability?: IFdLiability;
  applicationId: number;
}) => {
  const [allLiabilities, setAllLiabilities] = useState<IGenericType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasSuccessfullyUpdated, setHasSuccessfullyUpdated] = useState(false);

  const isAdding = !props.liability?.id;

  useEffect(() => {
    // signal edit started
    reduxSetSidePanelEditState('editing');
    apiGetFdLiabilities()
      .then((liabilities) => setAllLiabilities(liabilities))
      .catch((err) => {
        alert('Failed to load liabilities. Please try again later.');
        console.error('Failed to load liabilities', err);
      });
    return () => {
      // reset when panel unmounts if not saved
      reduxSetSidePanelEditState('idle');
    };
  }, []);

  const handleCancel = () => {
    reduxToggleSidePanel(false, null);
  };

  const handleSubmit = (submission: Submission) => {
    setIsLoading(true);
    apiUpsertFdLiability({
      id: props.liability?.id ? parseInt(props.liability?.id) : undefined,
      creditLimitAmount: submission.creditLimitAmount,
      currentBalanceLimit: submission.currentBalanceLimit,
      monthlyInstallmentAmount: submission.monthlyInstallmentAmount,
      inArrears: submission.inArrears,
      liabilityAccountTypeId: submission.liabilityAccountTypeId,
      lender: submission.lender,
      applicationId: props.applicationId,
    })
      .then(() => {
        setHasSuccessfullyUpdated(true);
        // mark as saved for ApplicationDetail to refetch
        reduxSetSidePanelEditState('saved');
      })
      .catch((err) => {
        alert(
          'Failed to update liability at the moment. Please try again later',
        );
        console.error('Failed to update liability', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const canWrite = true;
  // Close via side-effect after success
  useEffect(() => {
    if (hasSuccessfullyUpdated) {
      reduxToggleSidePanel(false, null);
    }
  }, [hasSuccessfullyUpdated]);

  if (hasSuccessfullyUpdated) return null;

  if (!allLiabilities.length) {
    return (
      <Box margin={2}>
        <Skeleton variant="text" height={100} />
      </Box>
    );
  }

  return (
    <FdLiabilityForm
      liability={props.liability}
      allLiabilities={allLiabilities}
      isLoading={isLoading}
      submitButtonTitle={isAdding ? 'Add' : 'Update'}
      onSubmit={handleSubmit}
      cancelButtonTitle={'Cancel'}
      onCancel={handleCancel}
      readonly={!canWrite}
    />
  );
};

export default AddOrUpdateFdLiability;
